
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { WebAtendimentoCategoria } from "../models/webAtendimentoCategoria";
import { ApiService } from "./api.services";


export class WebAtendimentoCategoriaService extends ApiService {

    private strAction = 'api/WebAtendimentoCategoria';
    dialogData: any;
    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<WebAtendimentoCategoria[]> {
        return this.get<WebAtendimentoCategoria[]>(this.strAction + `/GetAll`);
    }
        
  }
